export enum ActivityPlaceSelectionType {
  Preselected = 'PRESELECTED',
  Unavailable = 'UNAVAILABLE'
}
